<div>
    <div class="breadcrumb">
        <span class="breadcrumb-previous" (click)="goTo('home')">Home</span> >
        <span class="breadcrumb-current">Gestione Prenotazioni</span>
    </div>

    <div class="menu-buttons">
      @if (viewReservation) {
        <div matRipple [matRippleCentered]="false" [matRippleDisabled]="false"
             [matRippleUnbounded]="false" class="menu-elements" (click)="goTo('report')">
          <div>
            <mat-icon svgIcon="reservation-report" aria-hidden="false"
                      style="height: 150px; width: 150px;"></mat-icon>
          </div>
          <div style="margin-top: 15px">Estrazione Prenotazioni</div>
        </div>
      }

      @if (anotherReservation) {
        <div class="menu-elements" matRipple [matRippleCentered]="false"
             [matRippleDisabled]="false" [matRippleUnbounded]="false" (click)="goTo('another')">
          <div>
            <mat-icon svgIcon="reservation-another" aria-hidden="false"
                      style="height: 150px; width: 150px;"></mat-icon>
          </div>
          <div style="margin-top: 15px">Prenotazione Per Conto Terzi</div>
        </div>
      }

      @if (massReservation) {
        <div class="menu-elements" matRipple [matRippleCentered]="false"
             [matRippleDisabled]="false" [matRippleUnbounded]="false" (click)="openShipSelectionDialog()">
          <div>
            <mat-icon svgIcon="reservation-mass" aria-hidden="false"
                      style="height: 150px; width: 150px;"></mat-icon>
          </div>
          <div style="margin-top: 15px">Prenotazione Massiva</div>
        </div>
      }

    </div>
</div>
